module.exports = __webpack_public_path__ + "img/tab.0a99271.svg";